
import Component from 'vue-class-component';
import Vue from 'vue';
import { Emit, Prop, Watch } from 'vue-property-decorator';
import { HelpCenterFIContactInfo } from '@/help-center/types/help-center-fi-contact-info';
import { LoanESignModalState } from '@/loan/types/loan-esign-modal-state';
import { LoanHelper } from '@/loan/helper';
import { Alert } from '@/core/types/alert';
import { AlertTypeEnum } from '@/core/types/alert-type-enum';

@Component
export default class LoanESignModal extends Vue {
	public alert: Alert | null = null;

	@Prop()
	public fiContactInfo!: HelpCenterFIContactInfo;

	public localState: LoanESignModalState = LoanHelper.getEsignModalDefaultState();

	@Prop()
	public state!: LoanESignModalState;

	@Emit('complete')
	public emitComplete(): boolean {
		this.setLocalState(LoanHelper.getEsignModalDefaultState());
		return true;
	}

	@Watch('state')
	public watchState(state: LoanESignModalState): void {
		this.setLocalState({ ...state });

		if (state.wasUpdateTried && !state.wasUpdateSuccessful) {
			this.alert = {
				type: AlertTypeEnum.ERROR,
				message: 'There was an issue sending the update request.',
			};

			return;
		}

		this.alert = null;
	}

	private setLocalState(state: LoanESignModalState): void {
		this.localState = state;
	}
}
